import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StandardApiResponse } from '@app/interfaces/standard-api-response';
import { GlobalUnitModel } from '@app/models/system-settings';
import { IEditService, IListService } from '@app/services';
import { ApiResponse } from '@app/shared/models';

@Injectable()
export class GlobalUnitService implements IListService, IEditService<GlobalUnitModel> {
	endpointBase = '/api/global-unit';

	constructor(private readonly http: HttpClient) {}

	getList() {
		return this.http.get<ApiResponse<'units', GlobalUnitModel[]>>(this.endpointBase + '/list');
	}

	getById(id: number) {
		return this.http.get<StandardApiResponse<GlobalUnitModel>>(`${this.endpointBase}/${id}`);
	}

	getListByUser() {
		return this.http.get<StandardApiResponse<GlobalUnitModel[]>>(`${this.endpointBase}/list-by-user`);
	}

	createEntity(entity: GlobalUnitModel) {
		return this.http.put<StandardApiResponse<number>>(this.endpointBase, entity);
	}

	updateEntity(entity: GlobalUnitModel) {
		return this.http.post<StandardApiResponse<any>>(this.endpointBase, entity);
	}

	deleteEntity(id: number): Observable<any> {
		return this.http.delete(`${this.endpointBase}/${id}`);
	}

	testConnection(entity: GlobalUnitModel) {
		return this.http.post<StandardApiResponse<any>>(this.endpointBase + '/test-connection', entity);
	}

	getListWithModule(): Observable<any> {
		// This method was only used by CustomQueryToolListComponent and isn't relevant to School Bookkeeping.
		// It can be removed when CustomQueryToolListComponent is removed.
		throw new Error('Method has been removed.');
	}

	getHomeDbServerName() {
		return this.http.get<ApiResponse<'serverName', string>>(`${this.endpointBase}/getHomeDbServerName`);
	}

	getUnitDbServerName() {
		return this.http.get<ApiResponse<'serverName', string>>(`${this.endpointBase}/getUnitDbServerName`);
	}

	getUnitDatabaseName() {
		return this.http.get<ApiResponse<'databaseName', string>>(`${this.endpointBase}/getUnitDatabaseName`);
	}

	getExportListUrl(): string {
		return `${this.endpointBase}/unit-list-export`;
	}
}
